export default {
  title: 'green',

  colors: {
    twitter: 'rgb(15, 184, 96)',
    darkhover: '#04130B',
    lighthover: '#1C1F23'
  },
};